/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Brand_Reference_HintInputs */

const he_notifications_tags_brand_reference_hint = /** @type {(inputs: Notifications_Tags_Brand_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות על מוצרים התואמים לתגיות ולמותגים שנבחרו`)
};

const en_notifications_tags_brand_reference_hint = /** @type {(inputs: Notifications_Tags_Brand_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications for products matching the selected tags and brands`)
};

/**
* | output |
* | --- |
* | "Notifications for products matching the selected tags and brands" |
*
* @param {Notifications_Tags_Brand_Reference_HintInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_brand_reference_hint = /** @type {((inputs?: Notifications_Tags_Brand_Reference_HintInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Brand_Reference_HintInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_brand_reference_hint(inputs)
	return en_notifications_tags_brand_reference_hint(inputs)
});